import { createStyles, makeStyles } from '@hawkins/styles';
export var cardStyles = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name to apply to the root of the component */
        root: {
            padding: 0,
            transition: 'box-shadow 0.3s, background-color 0.3s',
        },
        /** Class name to apply when 'fullScreen' is true */
        rootFullScreen: {
            color: hawkins.textColor.textColorRegular,
            backgroundColor: hawkins.ui.backgroundColor1,
            position: 'absolute',
            padding: "".concat(hawkinsVariables.spacings.space3, " ").concat(hawkinsVariables.spacings.space3, " 0 ").concat(hawkinsVariables.spacings.space3),
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
        },
    });
};
export var useCardStyles = makeStyles(cardStyles, { name: 'Hawkins-Card' });
